// Simple example of a React "smart" component

import { connect } from 'react-redux';
import TicketingSettings from '../components/TicketingSettings';
import * as actions from '../actions/ticketingSettingsActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  csrfToken: state.csrfToken,
  team: state.team,
  currentUser: state.currentUser,
  venueOwnerships: state.venueOwnerships,
  selectedVenueOwnership: state.selectedVenueOwnership,
  maxDescriptorLength: state.maxDescriptorLength,
  eventOrderFormAvailable: state.eventOrderFormAvailable,
  seatingSettings: state.seatingSettings,
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectedVenueOwnershipChanged: (venueOwnership) => dispatch(actions.selectedVenueOwnershipChanged(venueOwnership)),
    updateVenueOwnership: (csrfToken, team, venueOwnership) => dispatch(actions.updateVenueOwnership(dispatch, csrfToken, team, venueOwnership)),
    seatingSettingsUpdated: (venueOwnershipId, seatingData) => dispatch(actions.seatingSettingsUpdated(venueOwnershipId, seatingData)),
    customFieldsChanged: (venueOwnershipId, customFields) => dispatch(actions.customFieldsChanged(venueOwnershipId, customFields))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(TicketingSettings);
